{
  "name": "webapp-uart",
  "version": "0.30.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:themes": "node themes/build.mjs"
  },
  "private": true,
  "packageManager": "npm@12.0.2",
  "dependencies": {
    "@angular/cdk": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@ant-design/colors": "^7.2.1",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@openxiot/xiot-core-spec-ts": "^0.2.0",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.8",
    "ng-zorro-antd": "^22.1.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "22.2.1",
    "@angular/cli": "22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "jsdom": "^28.0.0",
    "less": "^4.9.1",
    "prettier": "^3.9.9",
    "typescript": "~6.0.2",
    "vitest": "^4.0.8"
  }
}
